import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const SyncThirdPartyToPennylane_MutationDocument = graphql(`
  mutation SyncThirdPartyToPennylane(
    $thirdPartyId: Id!
    $userAccount: PennylaneUserAccountEnum!
  ) {
    syncThirdPartyToPennylane(
      thirdPartyId: $thirdPartyId
      userAccount: $userAccount
    )
  }
`);

export const useSyncThirdPartyToPennylaneMutation = () =>
  useGraphQLMutation(SyncThirdPartyToPennylane_MutationDocument);
